module.exports = __webpack_public_path__ + "static/media/IconSettings.3b4409f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/IconSettings.svg
// module id = 940
// module chunks = 0